module.exports = "https://web-assets.ifttt.com/packs/media/layout/chevron-left-black-ad2f4de5.svg";